var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _path, _path2, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _path3, _path4, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _path5, _path6, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "header-logo",
    viewBox: "0 0 60 60",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87396 36.032L0 41.1684H8.61667L11.7887 37.2216L3.37136 59.9958H9.53815L16.4049 41.1639H26.6873L28.5613 36.0276L1.87396 36.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3948 36.0319L46.4794 54.888L46.8648 49.6013L36.4074 36.0319H31.2883L22.5498 60.0001H28.741L34.1923 45.0708L45.6775 60.0001H50.8541L59.5949 36.0319H53.3948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.418457 33.3918H14.0346L16.2785 23.7979L13.3568 20.0612L14.6437 16.2095L20.1172 7.90022L22.5117 10.8056L20.8592 13.4014L22.8794 20.4658L14.0346 33.3918H38.7328L30.2268 26.7807L32.0698 21.7394L27.8611 15.0885L31.3122 9.03229L30.4926 2.28184L35.5763 17.0652L42.5006 20.9876L38.735 33.3918H59.9998L45.1742 5.04128L41.2735 11.6745L36.9828 7.09317L34.8564 7.95992L30.2291 0L23.1895 9.54969L20.2102 5.88149L12.2625 14.717L7.25864 16.707L0.418457 33.3918ZM45.5486 22.5929L44.6736 16.3864L46.5409 13.0521L43.7809 10.5646L45.2207 7.88695L50.3154 17.8501L49.1392 22.0136L54.5861 33.4007L45.5486 22.5929Z",
    fill: "white"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "menu-icon",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 20,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 20,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 20,
    height: 2,
    rx: 1,
    fill: "white"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "menu-icon-cross",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.3828,
    y: 11.689,
    width: 10.4566,
    height: 2,
    rx: 1,
    transform: "rotate(-45 10.3828 11.689)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.99023,
    y: 4.36865,
    width: 19.6828,
    height: 2,
    rx: 1,
    transform: "rotate(45 4.99023 4.36865)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.1421,
    width: 11.0997,
    height: 2,
    rx: 1,
    transform: "rotate(-45 4 18.1421)",
    fill: "white"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "fullscreen-icon",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 8V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "volume-icon",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5.07001L6 9.07001H2V15.07H6L11 19.07V5.07001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54 8.53C16.4773 9.46764 17.0039 10.7392 17.0039 12.065C17.0039 13.3908 16.4773 14.6624 15.54 15.6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07 5C20.9447 6.87528 21.9979 9.41836 21.9979 12.07C21.9979 14.7216 20.9447 17.2647 19.07 19.14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "volume-off",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5.07031L6 9.07031H2V15.0703H6L11 19.0703V5.07031Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9L16 15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9L22 15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "route-icon",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6L9 3L15 6L21 3V18L15 21L9 18L3 21V6Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3V18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6V21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "backpack-icon",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20V10C4 8.93913 4.42143 7.92172 5.17157 7.17157C5.92172 6.42143 6.93913 6 8 6H16C17.0609 6 18.0783 6.42143 18.8284 7.17157C19.5786 7.92172 20 8.93913 20 10V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6V4C9 3.46957 9.21071 2.96086 9.58579 2.58579C9.96086 2.21071 10.4696 2 11 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21V16C8 15.4696 8.21071 14.9609 8.58579 14.5858C8.96086 14.2107 9.46957 14 10 14H14C14.5304 14 15.0391 14.2107 15.4142 14.5858C15.7893 14.9609 16 15.4696 16 16V21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10H16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18H16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "button-bg",
    viewBox: "0 0 297 54"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.353 8.99491L276.018 0H297V54H0V42.3563L11.1916 33.3L0 36.332V0H271.678L270.353 8.99491Z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "start-page-btn-green-bg",
    viewBox: "0 0 149 60"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.353 8.99491L137.017 0H149V60H0V47.3562L11.1916 38.3L0 41.332V0H132.678L131.353 8.99491Z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "start-page-btn-white-bg",
    viewBox: "0 0 156 60"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.51 7.99491L141.782 0H156V60H0V47.3562L11.7174 38.3L0 41.332V0H137.743L136.51 7.99491Z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "start-page-btn-white-bg2",
    viewBox: "0 0 205 83"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.72 12.3756L188.514 0H205V82.5503H0V65.1546L15.3978 52.6946L0 56.8662V0H182.543L180.72 12.3756Z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "train-station-page-btn-green-bg",
    viewBox: "0 0 238 54"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.353 8.99491L222.018 0H238V54H0V42.3563L11.1916 33.3L0 36.332V0H217.678L216.353 8.99491Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "after-game-page-btn-green-bg",
    viewBox: "0 0 249 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.353 8.99491L227.018 0H249V54H0V42.3563L11.1916 33.3L0 36.332V0H222.678L221.353 8.99491Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "after-game-page-btn-border-bg",
    viewBox: "0 0 180 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.018 0V-1H158.466L158.171 -0.532896L159.018 0ZM153.353 8.99491L152.364 8.84918L154.199 9.52781L153.353 8.99491ZM180 0H181V-1H180V0ZM180 54V55H181V54H180ZM0 54H-1V55H0V54ZM0 42.3563L-0.629047 41.5789L-1 41.8791V42.3563H0ZM11.1916 33.3L11.8206 34.0774L10.9301 32.3348L11.1916 33.3ZM0 36.332H-1V37.639L0.261491 37.2972L0 36.332ZM0 0V-1H-1V0H0ZM154.678 0L155.667 0.145737L155.836 -1H154.678V0ZM158.171 -0.532896L152.507 8.46202L154.199 9.52781L159.864 0.532896L158.171 -0.532896ZM180 -1H159.018V1H180V-1ZM181 54V0H179V54H181ZM0 55H180V53H0V55ZM-1 42.3563V54H1V42.3563H-1ZM0.629047 43.1336L11.8206 34.0774L10.5625 32.5227L-0.629047 41.5789L0.629047 43.1336ZM10.9301 32.3348L-0.261491 35.3668L0.261491 37.2972L11.4531 34.2652L10.9301 32.3348ZM-1 0V36.332H1V0H-1ZM154.678 -1H0V1H154.678V-1ZM154.342 9.14065L155.667 0.145737L153.689 -0.145737L152.364 8.84918L154.342 9.14065Z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "feature-knowledge-bg",
    viewBox: "0 0 90 30",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5412 4.79518L72.7822 0H75.0007C83.285 0 90.0007 6.71573 90.0007 15C90.0007 23.2843 83.285 30 75.0007 30H15.0007C7.41123 30 1.13822 24.3635 0.139381 17.0482L6.96175 15.9702L0.0253906 14.1321C0.474945 6.25173 7.00774 0 15.0007 0H70.0687L68.5412 4.79518Z",
    fill: "#99BE03"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "feature-experience-bg",
    viewBox: "0 0 80 30",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5403 4.79518L64.7813 0H64.9998C73.284 0 79.9998 6.71573 79.9998 15C79.9998 23.2843 73.284 30 64.9998 30H14.9998C7.35683 30 1.04898 24.2838 0.118117 16.8934L5.96081 15.9702L0.0117838 14.3937C0.32991 6.39055 6.91854 0 14.9998 0H62.0678L60.5403 4.79518Z",
    fill: "#99BE03"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "feature-skill-bg",
    viewBox: "0 0 109 30",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5412 4.79518L91.7823 0H94.0007C102.285 0 109.001 6.71573 109.001 15C109.001 23.2843 102.285 30 94.0007 30H15.0007C7.41125 30 1.13825 24.3635 0.139412 17.0482L6.96178 15.9702L0.0254207 14.1321C0.474976 6.25173 7.00777 0 15.0007 0H89.0688L87.5412 4.79518Z",
    fill: "#99BE03"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "after-meadow-skill-progress-strong",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00006C4.29058 0 1.17077 2.52472 0.265259 5.94954L10.5155 6.77788L0.34192 10.3209C1.33661 13.6074 4.38892 16 8.00006 16H154C158.418 16 162 12.4183 162 8C162 3.58172 158.418 0 154 0H145.222Z",
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5155 6.77788L0.265259 5.94954C1.17077 2.52472 4.29058 0 8.00006 0H46.0001C50.4183 0 54.0001 3.58172 54.0001 8C54.0001 12.4183 50.4183 16 46.0001 16H8.00006C4.38892 16 1.33661 13.6074 0.34192 10.3209L10.5155 6.77788Z",
    fill: "#99BE03"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "after-meadow-skill-progress-dexterity",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00006C4.29058 0 1.17077 2.52472 0.265259 5.94954L10.5155 6.77788L0.34192 10.3209C1.33661 13.6074 4.38892 16 8.00006 16H154C158.418 16 162 12.4183 162 8C162 3.58172 158.418 0 154 0H145.222Z",
    fill: "black",
    fillOpacity: 0.4
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "after-meadow-skill-progress-exp",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00006C4.29058 0 1.17077 2.52472 0.265259 5.94954L10.5155 6.77788L0.34192 10.3209C1.33661 13.6074 4.38892 16 8.00006 16H154C158.418 16 162 12.4183 162 8C162 3.58172 158.418 0 154 0H145.222Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00006C4.29058 0 1.17077 2.52472 0.265259 5.94954L10.5155 6.77788L0.34192 10.3209C1.33661 13.6074 4.38892 16 8.00006 16H154C158.418 16 162 12.4183 162 8C162 3.58172 158.418 0 154 0H145.222Z",
    fill: "#99BE03"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "after-meadow-skill-progress-skill",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00006C4.29058 0 1.17077 2.52472 0.265259 5.94954L10.5155 6.77788L0.34192 10.3209C1.33661 13.6074 4.38892 16 8.00006 16H154C158.418 16 162 12.4183 162 8C162 3.58172 158.418 0 154 0H145.222Z",
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5155 6.77788L0.265259 5.94954C1.17077 2.52472 4.29058 0 8.00006 0H46.0001C50.4183 0 54.0001 3.58172 54.0001 8C54.0001 12.4183 50.4183 16 46.0001 16H8.00006C4.38892 16 1.33661 13.6074 0.34192 10.3209L10.5155 6.77788Z",
    fill: "#99BE03"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "after-meadow-skill-progress-knowledge",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00006C4.29058 0 1.17077 2.52472 0.265259 5.94954L10.5155 6.77788L0.34192 10.3209C1.33661 13.6074 4.38892 16 8.00006 16H154C158.418 16 162 12.4183 162 8C162 3.58172 158.418 0 154 0H145.222Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5155 6.77788L0.265259 5.94954C1.17077 2.52472 4.29058 0 8.00006 0H46.0001C50.4183 0 54.0001 3.58172 54.0001 8C54.0001 12.4183 50.4183 16 46.0001 16H8.00006C4.38892 16 1.33661 13.6074 0.34192 10.3209L10.5155 6.77788Z",
    fill: "#99BE03"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "double-arrow-right",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18L12 12L6 6",
    stroke: "#99BE03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18L18 12L12 6",
    stroke: "#99BE03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "video-play-btn",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7507 18.5525L49.1966 6.94493C55.7985 12.448 60 20.7333 60 30C60 46.5685 46.5685 60 30 60C15.7135 60 3.7594 50.0136 0.737493 36.6406L12.2054 27.4764L0.00802575 30.7009C0.00268495 30.4679 0 30.2343 0 30C0 13.4315 13.4315 0 30 0C35.0156 0 39.7437 1.23083 43.8987 3.40691L39.7507 18.5525Z",
    fill: "#99BE03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 21.5625L38.4375 30L25.3125 38.4375V21.5625Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "video-stop-btn",
    width: 60,
    height: 60,
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2004 9.89445L26.2381 3.70389C29.7592 6.63884 32 11.0577 32 16C32 24.8366 24.8366 32 16 32C8.38055 32 2.00506 26.674 0.393348 19.5418L6.50956 14.6542L0.00428261 16.3739C0.00143271 16.2496 0 16.125 0 16C0 7.16344 7.16344 0 16 0C18.675 0 21.1966 0.656433 23.4126 1.817L21.2004 9.89445Z",
    fill: "#FF0101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13L13 19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13L19 19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "map-icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1988 9.8944L26.2371 3.70309C29.7588 6.63804 32 11.0573 32 16C32 24.8366 24.8366 32 16 32C8.38099 32 2.0058 26.6746 0.393628 19.543L6.51151 14.6541L0.00429217 16.3743C0.00143592 16.2499 0 16.1251 0 16C0 7.16344 7.16344 0 16 0C18.6744 0 21.1956 0.656161 23.4112 1.81628L21.1988 9.8944Z",
    fill: "#99BE03"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "map-icon-active",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7576_69958",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4995 12.3681L32.797 4.62937C37.1987 8.29806 40 13.8219 40 20C40 31.0457 31.0457 40 20 40C10.4758 40 2.50652 33.3426 0.49176 24.4275L8.13744 18.3177L0.00535625 20.4675C0.00179189 20.3121 0 20.1563 0 20C0 8.9543 8.9543 0 20 0C23.3434 0 26.4951 0.820372 29.2649 2.2708L26.4995 12.3681Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4995 12.3681L32.797 4.62937C37.1987 8.29806 40 13.8219 40 20C40 31.0457 31.0457 40 20 40C10.4758 40 2.50652 33.3426 0.49176 24.4275L8.13744 18.3177L0.00535625 20.4675C0.00179189 20.3121 0 20.1563 0 20C0 8.9543 8.9543 0 20 0C23.3434 0 26.4951 0.820372 29.2649 2.2708L26.4995 12.3681Z",
    fill: "#99BE03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.797 4.62937L33.1172 4.24529L32.7285 3.92139L32.4092 4.31378L32.797 4.62937ZM26.4995 12.3681L26.0173 12.236L26.8873 12.6837L26.4995 12.3681ZM0.49176 24.4275L0.179623 24.0369L-0.0649537 24.2324L0.00405928 24.5377L0.49176 24.4275ZM8.13744 18.3177L8.44958 18.7083L8.00965 17.8343L8.13744 18.3177ZM0.00535624 20.4675L-0.494512 20.479L-0.47997 21.113L0.133144 20.9509L0.00535624 20.4675ZM29.2649 2.2708L29.7472 2.40287L29.8535 2.01461L29.4969 1.82786L29.2649 2.2708ZM32.4092 4.31378L30.8348 6.24845L31.6105 6.87964L33.1848 4.94497L32.4092 4.31378ZM27.6861 10.1178L26.1117 12.0525L26.8873 12.6837L28.4617 10.749L27.6861 10.1178ZM26.9818 12.5001L27.6731 9.97582L26.7086 9.71167L26.0173 12.236L26.9818 12.5001ZM29.0558 4.92719L29.7472 2.40287L28.7827 2.13872L28.0913 4.66304L29.0558 4.92719ZM29.4969 1.82786C28.7711 1.44782 28.0198 1.10996 27.2461 0.817548L26.8925 1.75297C27.6282 2.03102 28.3427 2.3523 29.033 2.71374L29.4969 1.82786ZM22.462 -0.353626C21.6546 -0.450289 20.833 -0.5 20 -0.5V0.5C20.7932 0.5 21.5751 0.547333 22.3431 0.639283L22.462 -0.353626ZM20 -0.5C19.093 -0.5 18.1995 -0.441063 17.3231 -0.326754L17.4525 0.664846C18.286 0.556116 19.1363 0.5 20 0.5V-0.5ZM12.1527 1.05575C10.4858 1.74697 8.93014 2.65165 7.51965 3.73555L8.12898 4.52847C9.47097 3.49721 10.9507 2.63676 12.5358 1.97947L12.1527 1.05575ZM3.73555 7.51966C2.65165 8.93014 1.74697 10.4858 1.05575 12.1527L1.97947 12.5358C2.63676 10.9507 3.49721 9.47097 4.52847 8.12898L3.73555 7.51966ZM-0.326754 17.3231C-0.441063 18.1995 -0.5 19.093 -0.5 20H0.5C0.5 19.1363 0.556116 18.286 0.664845 17.4525L-0.326754 17.3231ZM-0.5 20C-0.5 20.0399 -0.499886 20.0799 -0.499657 20.1197L0.500326 20.114C0.500109 20.076 0.5 20.038 0.5 20H-0.5ZM-0.496914 20.3592C-0.496228 20.3992 -0.495427 20.4391 -0.494512 20.479L0.505225 20.456C0.504354 20.4181 0.503591 20.3801 0.502938 20.342L-0.496914 20.3592ZM0.133144 20.9509L2.16616 20.4134L1.91059 19.4467L-0.122431 19.9841L0.133144 20.9509ZM6.23221 19.3386L8.26523 18.8011L8.00965 17.8343L5.97663 18.3718L6.23221 19.3386ZM7.8253 17.9271L5.91388 19.4546L6.53816 20.2358L8.44958 18.7083L7.8253 17.9271ZM2.09104 22.5095L0.179623 24.0369L0.803897 24.8181L2.71532 23.2907L2.09104 22.5095ZM0.00405928 24.5377C0.260528 25.6726 0.611119 26.7718 1.04718 27.8266L1.97133 27.4446C1.55668 26.4415 1.22333 25.3964 0.979461 24.3173L0.00405928 24.5377ZM4.70367 33.6485C6.23417 35.3626 8.04865 36.8179 10.0735 37.9406L10.5584 37.066C8.63241 35.9982 6.90598 34.6135 5.4496 32.9824L4.70367 33.6485ZM16.5624 40.2129C17.6804 40.4018 18.8289 40.5 20 40.5V39.5C18.885 39.5 17.7921 39.4065 16.7289 39.2269L16.5624 40.2129ZM20 40.5C20.907 40.5 21.8005 40.4411 22.6769 40.3268L22.5475 39.3352C21.714 39.4439 20.8637 39.5 20 39.5V40.5ZM27.8473 38.9443C29.5142 38.253 31.0699 37.3483 32.4803 36.2644L31.871 35.4715C30.529 36.5028 29.0493 37.3632 27.4642 38.0205L27.8473 38.9443ZM36.2645 32.4803C37.3484 31.0699 38.253 29.5142 38.9443 27.8473L38.0205 27.4642C37.3632 29.0493 36.5028 30.529 35.4715 31.871L36.2645 32.4803ZM40.3268 22.6769C40.4411 21.8005 40.5 20.907 40.5 20H39.5C39.5 20.8637 39.4439 21.714 39.3352 22.5475L40.3268 22.6769ZM40.5 20C40.5 18.4698 40.3323 16.9783 40.014 15.5429L39.0377 15.7594C39.3403 17.1241 39.5 18.5431 39.5 20H40.5ZM36.2285 7.47302C35.3117 6.28701 34.2678 5.20431 33.1172 4.24529L32.4769 5.01346C33.5717 5.92596 34.565 6.95617 35.4373 8.08461L36.2285 7.47302ZM32.797 4.62937L33.4373 3.86121L32.66 3.2134L32.0214 3.99819L32.797 4.62937ZM26.4995 12.3681L25.535 12.1039L27.2752 12.9992L26.4995 12.3681ZM0.49176 24.4275L-0.132514 23.6463L-0.621668 24.0372L-0.483642 24.648L0.49176 24.4275ZM8.13744 18.3177L8.76171 19.0989L7.88186 17.3509L8.13744 18.3177ZM0.00535624 20.4675L-0.994381 20.4904L-0.965296 21.7584L0.260931 21.4343L0.00535624 20.4675ZM29.2649 2.2708L30.2294 2.53495L30.4421 1.75841L29.7288 1.38491L29.2649 2.2708ZM32.0214 3.99819L30.447 5.93286L31.9983 7.19523L33.5727 5.26056L32.0214 3.99819ZM27.2983 9.8022L25.7239 11.7369L27.2752 12.9992L28.8495 11.0646L27.2983 9.8022ZM27.464 12.6322L28.1554 10.1079L26.2264 9.5796L25.535 12.1039L27.464 12.6322ZM29.5381 5.05926L30.2294 2.53495L28.3004 2.00665L27.6091 4.53097L29.5381 5.05926ZM29.7288 1.38491C28.9853 0.995581 28.2156 0.649435 27.4228 0.349836L26.7158 2.22068C27.4325 2.49154 28.1286 2.80454 28.801 3.15669L29.7288 1.38491ZM22.5215 -0.850081C21.6944 -0.9491 20.8529 -1 20 -1V1C20.7733 1 21.5354 1.04614 22.2837 1.13574L22.5215 -0.850081ZM20 -1C19.0713 -1 18.1562 -0.939653 17.2585 -0.822554L17.5172 1.16065C18.3293 1.05471 19.158 1 20 1V-1ZM11.9612 0.593885C10.2534 1.30208 8.65972 2.22887 7.21499 3.33909L8.43364 4.92493C9.74138 3.91999 11.1832 3.08165 12.7273 2.44134L11.9612 0.593885ZM3.33909 7.21499C2.22887 8.65973 1.30208 10.2534 0.593883 11.9612L2.44134 12.7273C3.08165 11.1832 3.91998 9.74139 4.92493 8.43365L3.33909 7.21499ZM-0.822554 17.2585C-0.939653 18.1562 -1 19.0713 -1 20H1C1 19.158 1.05471 18.3293 1.16064 17.5172L-0.822554 17.2585ZM-1 20C-1 20.0409 -0.999883 20.0818 -0.999649 20.1226L1.00032 20.1112C1.00011 20.0741 1 20.0371 1 20H-1ZM-0.996841 20.3678C-0.996138 20.4087 -0.995318 20.4496 -0.994381 20.4904L1.00509 20.4446C1.00424 20.4075 1.0035 20.3705 1.00286 20.3334L-0.996841 20.3678ZM0.260931 21.4343L2.29395 20.8968L1.7828 18.9633L-0.250219 19.5007L0.260931 21.4343ZM6.35999 19.822L8.39301 19.2845L7.88186 17.3509L5.84884 17.8884L6.35999 19.822ZM7.51316 17.5365L5.60175 19.064L6.85029 20.6264L8.76171 19.0989L7.51316 17.5365ZM1.77891 22.1189L-0.132514 23.6463L1.11603 25.2087L3.02745 23.6813L1.77891 22.1189ZM-0.483642 24.648C-0.220873 25.8107 0.138336 26.9369 0.585111 28.0176L2.4334 27.2535C2.02947 26.2764 1.70473 25.2583 1.46716 24.2071L-0.483642 24.648ZM4.33071 33.9815C5.89826 35.7371 7.75677 37.2278 9.83103 38.3779L10.8008 36.6287C8.92429 35.5883 7.24189 34.239 5.82257 32.6494L4.33071 33.9815ZM16.4791 40.706C17.6246 40.8994 18.8009 41 20 41V39C18.913 39 17.848 38.9088 16.8121 38.7339L16.4791 40.706ZM20 41C20.9287 41 21.8438 40.9397 22.7415 40.8226L22.4828 38.8394C21.6707 38.9453 20.842 39 20 39V41ZM28.0388 39.4061C29.7466 38.6979 31.3403 37.7711 32.785 36.6609L31.5664 35.0751C30.2586 36.08 28.8168 36.9183 27.2727 37.5587L28.0388 39.4061ZM36.6609 32.785C37.7711 31.3403 38.6979 29.7466 39.4061 28.0388L37.5587 27.2727C36.9183 28.8168 36.08 30.2586 35.0751 31.5664L36.6609 32.785ZM40.8226 22.7415C40.9397 21.8438 41 20.9287 41 20H39C39 20.842 38.9453 21.6707 38.8394 22.4828L40.8226 22.7415ZM41 20C41 18.4332 40.8282 16.9053 40.5021 15.4347L38.5496 15.8676C38.8443 17.1971 39 18.5798 39 20H41ZM36.6241 7.16722C35.685 5.95242 34.6158 4.84348 33.4373 3.86121L32.1568 5.39754C33.2237 6.28679 34.1917 7.29076 35.0417 8.3904L36.6241 7.16722Z",
    fill: "white",
    mask: "url(#path-1-inside-1_7576_69958)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 6,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "map-icon-finished",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1988 9.8944L26.2371 3.70309C29.7588 6.63804 32 11.0573 32 16C32 24.8366 24.8366 32 16 32C8.38099 32 2.0058 26.6746 0.393628 19.543L6.51151 14.6541L0.00429217 16.3743C0.00143592 16.2499 0 16.1251 0 16C0 7.16344 7.16344 0 16 0C18.6744 0 21.1956 0.656161 23.4112 1.81628L21.1988 9.8944Z",
    fill: "#99BE03"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4019 10.5441C15.6464 10.0486 16.3529 10.0486 16.5975 10.5441L17.9047 13.1924C18.0017 13.389 18.1892 13.5253 18.4061 13.557L21.3305 13.9844C21.8771 14.0643 22.095 14.7362 21.6992 15.1216L19.5842 17.1817C19.427 17.3348 19.3552 17.5556 19.3923 17.7719L19.8913 20.6814C19.9847 21.2261 19.413 21.6414 18.9239 21.3842L16.31 20.0095C16.1157 19.9074 15.8836 19.9074 15.6894 20.0095L13.0754 21.3842C12.5863 21.6414 12.0146 21.2261 12.1081 20.6814L12.6071 17.7719C12.6442 17.5556 12.5724 17.3348 12.4151 17.1817L10.3001 15.1216C9.9044 14.7362 10.1223 14.0643 10.6689 13.9844L13.5933 13.557C13.8102 13.5253 13.9976 13.389 14.0946 13.1924L15.4019 10.5441Z",
    fill: "white"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "map-icon-disabled",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1988 9.8944L26.2371 3.70309C29.7588 6.63804 32 11.0573 32 16C32 24.8366 24.8366 32 16 32C8.38099 32 2.0058 26.6746 0.393628 19.543L6.51151 14.6541L0.00429216 16.3743C0.00143591 16.2499 -9.20105e-09 16.1251 -9.12966e-09 16C-4.08749e-09 7.16344 7.16344 4.08749e-09 16 9.12966e-09C18.6744 1.06557e-08 21.1956 0.656161 23.4112 1.81628L21.1988 9.8944Z",
    fill: "#99BE03"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7575_103008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.942 14.9021L19.4263 14.9021L19.4262 14.9021L19.4262 13.0858C19.4262 11.1641 17.8627 9.60059 15.9409 9.60059C14.0192 9.60059 12.4557 11.1641 12.4557 13.0859L12.4557 14.9021L11.9399 14.9021C11.5322 14.9021 11.2017 15.2326 11.2017 15.6404L11.2017 16.0895L11.2017 21.2132L11.2017 21.6623C11.2017 22.0701 11.5322 22.4006 11.9399 22.4006L15.9409 22.4006L19.942 22.4006C20.3497 22.4006 20.6802 22.0701 20.6802 21.6623L20.6802 21.2132L20.6802 16.0895L20.6802 15.6404C20.6802 15.2326 20.3497 14.9021 19.942 14.9021ZM16.7267 20.1904L15.1551 20.1904L15.4364 18.8501C15.1734 18.6827 14.9977 18.3904 14.9977 18.0555C14.9977 17.5346 15.42 17.1123 15.9409 17.1123C16.4619 17.1123 16.8841 17.5346 16.8841 18.0555C16.8841 18.3904 16.7085 18.6827 16.4455 18.85L16.7267 20.1904ZM18.1826 14.9021L15.9409 14.9021L13.6994 14.9021L13.6993 14.9021L13.6993 13.0858C13.6993 11.8497 14.7048 10.8442 15.9409 10.8442C17.1771 10.8442 18.1826 11.8497 18.1826 13.0858L18.1826 14.9021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7575_103008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(9.60156 9.60059)"
  }))))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7295_12704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.942 5.90161H10.4263H10.4262V4.08536C10.4262 2.16361 8.8627 0.600098 6.94091 0.600098C5.01921 0.600098 3.4557 2.16361 3.4557 4.08538V5.90163H2.93994C2.53223 5.90163 2.20166 6.23216 2.20166 6.63989V7.089V12.2127V12.6618C2.20166 13.0696 2.53221 13.4001 2.93994 13.4001H6.94093H10.942C11.3497 13.4001 11.6802 13.0696 11.6802 12.6618V12.2127V7.089V6.63989C11.6802 6.23213 11.3497 5.90161 10.942 5.90161ZM7.72674 11.1899H6.15515L6.43643 9.8496C6.17338 9.68221 5.99768 9.38992 5.99768 9.05502C5.99768 8.53411 6.42002 8.11182 6.94093 8.11182C7.46187 8.11182 7.88413 8.53411 7.88413 9.05502C7.88413 9.38992 7.70848 9.68221 7.44546 9.84955L7.72674 11.1899ZM9.1826 5.90161H6.94093H4.69939H4.69926V4.08536C4.69926 2.84919 5.70481 1.84367 6.94093 1.84367C8.1771 1.84367 9.1826 2.84921 9.1826 4.08536V5.90161Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7295_12704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(0.601562 0.600098)"
  }))))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "param-line-1",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00043C4.29094 0 1.17114 2.52472 0.265625 5.94954L10.5159 6.77788L0.342286 10.3209C1.33698 13.6074 4.38928 16 8.00042 16H154C158.419 16 162 12.4183 162 8C162 3.58172 158.419 0 154 0H145.222Z",
    fill: "#848484"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "param-line-2",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00043C4.29094 0 1.17114 2.52472 0.265625 5.94954L10.5159 6.77788L0.342286 10.3209C1.33698 13.6074 4.38928 16 8.00042 16H154C158.419 16 162 12.4183 162 8C162 3.58172 158.419 0 154 0H145.222Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5159 6.77788L0.265625 5.94954C1.17114 2.52472 4.29094 0 8.00043 0H46.0004C50.4187 0 54.0004 3.58172 54.0004 8C54.0004 12.4183 50.4187 16 46.0004 16H8.00042C4.38929 16 1.33698 13.6074 0.342286 10.3209L10.5159 6.77788Z",
    fill: "#99BE03"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "param-line-3",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00043C4.29094 0 1.17114 2.52472 0.265625 5.94954L10.5159 6.77788L0.342286 10.3209C1.33698 13.6074 4.38928 16 8.00042 16H154C158.419 16 162 12.4183 162 8C162 3.58172 158.419 0 154 0H145.222Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5159 6.77788L0.265625 5.94954C1.17114 2.52472 4.29094 0 8.00043 0H100C104.419 0 108 3.58172 108 8C108 12.4183 104.419 16 100 16H8.00043C4.38929 16 1.33698 13.6074 0.342286 10.3209L10.5159 6.77788Z",
    fill: "#99BE03"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "param-line-4",
    width: 162,
    height: 16,
    viewBox: "0 0 162 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00043C4.29094 0 1.17114 2.52472 0.265625 5.94954L10.5159 6.77788L0.342286 10.3209C1.33698 13.6074 4.38928 16 8.00042 16H154C158.419 16 162 12.4183 162 8C162 3.58172 158.419 0 154 0H145.222Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.222 0L138.252 7.62404L140.82 0H8.00043C4.29094 0 1.17114 2.52472 0.265625 5.94954L10.5159 6.77788L0.342286 10.3209C1.33698 13.6074 4.38928 16 8.00042 16H154C158.419 16 162 12.4183 162 8C162 3.58172 158.419 0 154 0H145.222Z",
    fill: "#99BE03"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "vk",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.31 1.69C20.63 0 17.91 0 12.48 0H11.48C6.08999 0 3.36999 0 1.69 1.69C0.0100001 3.38 0 6.08999 0 11.52V12.52C0 17.95 0 20.67 1.69 22.35C3.38 24.03 6.08999 24 11.52 24H12.52C17.95 24 20.67 24 22.35 22.31C24.03 20.62 24 17.91 24 12.48V11.48C24 6.08999 24 3.36999 22.31 1.69ZM17.22 17.29C16.9509 16.3573 16.4162 15.523 15.6811 14.8891C14.9459 14.2552 14.0421 13.8489 13.08 13.72V17.29H12.77C7.29999 17.29 4.17999 13.54 4.04999 7.28999H6.78999C6.87999 11.87 8.89999 13.81 10.5 14.21V7.29999H13.08V11.3C14.66 11.13 16.32 9.29999 16.88 7.34999H19.46C19.2509 8.38025 18.8312 9.35619 18.2272 10.2166C17.6232 11.077 16.8479 11.8033 15.95 12.35C16.9485 12.847 17.8308 13.5493 18.539 14.411C19.2473 15.2726 19.7656 16.2741 20.06 17.35L17.22 17.29Z",
    fill: "#99BE03"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "league",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7474_104307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.31 1.69C20.63 0 17.91 0 12.48 0H11.48C6.09 0 3.37 0 1.69 1.69C0.0100001 3.38 0 6.09 0 11.52V12.52C0 17.95 0 20.67 1.69 22.35C3.38 24.03 6.09 24 11.52 24H12.52C17.95 24 20.67 24 22.35 22.31C24.03 20.62 24 17.91 24 12.48V11.48C24 6.09 24 3.37 22.31 1.69Z",
    fill: "#99BE03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0191 11.3919L2 10.5968L7.30039 5L8.72431 5.89967L6.37281 12.5353L13.794 5L15.5067 6.12671L13.5799 11.3919L19.7879 5L22 6.47893L17.0049 20L14.7929 18.5211L17.7543 10.4453L11.6385 16.7151L9.79808 15.5635L12.0427 9.48227L7.51447 14.0846L4.66018 12.5002L6.12894 8.30979L3.0191 11.3919Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7474_104307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "youtube",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7474_104335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.31 1.69C20.63 0 17.91 0 12.48 0H11.48C6.09 0 3.37 0 1.69 1.69C0.0100001 3.38 0 6.09 0 11.52V12.52C0 17.95 0 20.67 1.69 22.35C3.38 24.03 6.09 24 11.52 24H12.52C17.95 24 20.67 24 22.35 22.31C24.03 20.62 24 17.91 24 12.48V11.48C24 6.09 24 3.37 22.31 1.69Z",
    fill: "#99BE03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.489 3H7.569L8.31 5.7765L8.997 3H10.0875L8.83875 7.12875V9.9465H7.7655V7.12875L6.489 3V3ZM11.4345 4.77975C10.5953 4.77975 10.0388 5.33475 10.0388 6.156V8.66775C10.0388 9.57075 10.5105 10.041 11.4345 10.041C12.201 10.041 12.804 9.52875 12.804 8.66775V6.156C12.804 5.35425 12.2063 4.77975 11.4345 4.77975ZM11.8328 8.625C11.8328 8.904 11.6902 9.1095 11.4338 9.1095C11.1705 9.1095 11.0182 8.89425 11.0182 8.625V6.24075C11.0182 5.96025 11.1473 5.7525 11.415 5.7525C11.7075 5.7525 11.8328 5.95425 11.8328 6.24075V8.625ZM15.3795 4.8225V8.712C15.2633 8.8575 15.0045 9.096 14.8193 9.096C14.616 9.096 14.5658 8.9565 14.5658 8.751V4.8225H13.6132V9.105C13.6132 9.61125 13.7677 10.02 14.2785 10.02C14.5665 10.02 14.967 9.87 15.3795 9.38025V9.94575H16.332V4.8225H15.3795ZM17.0317 15.216C16.6957 15.216 16.626 15.4522 16.626 15.7882V16.2825H17.4277V15.7875C17.4285 15.4575 17.3587 15.216 17.0317 15.216ZM13.5045 15.246C13.4415 15.2782 13.3792 15.3277 13.317 15.3945V18.4357C13.3912 18.5152 13.4625 18.5722 13.5323 18.6075C13.68 18.6825 13.896 18.6877 13.9965 18.5572C14.049 18.4882 14.0753 18.3765 14.0753 18.2205V15.7012C14.0753 15.5362 14.043 15.4117 13.9785 15.3262C13.8682 15.1815 13.6635 15.1657 13.5045 15.246ZM17.1248 11.3497C15.1718 11.217 8.82525 11.217 6.87525 11.3497C4.76475 11.4937 4.51575 12.7687 4.5 16.125C4.51575 19.4752 4.7625 20.7562 6.87525 20.9002C8.82525 21.033 15.1718 21.033 17.1248 20.9002C19.2353 20.7562 19.4843 19.4805 19.5 16.125C19.4843 12.7747 19.2375 11.4937 17.1248 11.3497ZM7.88175 19.3642H6.8595V13.7092H5.802V12.7492H8.9385V13.7092H7.881V19.3642H7.88175ZM11.5162 19.3642H10.6088V18.8257C10.4415 19.0245 10.2675 19.176 10.0868 19.2795C9.59775 19.56 8.9265 19.5532 8.9265 18.5632V14.4847H9.83325V18.2257C9.83325 18.4222 9.8805 18.5542 10.0747 18.5542C10.2517 18.5542 10.4977 18.327 10.608 18.189V14.4847H11.5155V19.3642H11.5162ZM15.009 18.3532C15.009 18.957 14.7832 19.4265 14.1795 19.4265C13.8472 19.4265 13.5705 19.305 13.3177 18.9892V19.3642H12.402V12.7492H13.3177V14.8792C13.5225 14.6295 13.8007 14.4232 14.1248 14.4232C14.7893 14.4232 15.0098 14.985 15.0098 15.6465V18.3532H15.009ZM18.3622 17.0392H16.6268V17.9602C16.6268 18.3262 16.6583 18.6427 17.0228 18.6427C17.406 18.6427 17.4285 18.3847 17.4285 17.9602V17.6212H18.3622V17.988C18.3622 18.9277 17.9587 19.4977 17.0025 19.4977C16.1363 19.4977 15.693 18.8662 15.693 17.988V15.7972C15.693 14.9505 16.2525 14.3617 17.0707 14.3617C17.9415 14.3617 18.3615 14.9152 18.3615 15.7972V17.0392H18.3622Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7474_104335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "telegram",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.31 1.69C20.63 0 17.91 0 12.48 0H11.48C6.08999 0 3.36999 0 1.69 1.69C0.0100001 3.38 0 6.08999 0 11.52V12.52C0 17.95 0 20.67 1.69 22.35C3.38 24.03 6.08999 24 11.52 24H12.52C17.95 24 20.67 24 22.35 22.31C24.03 20.62 24 17.91 24 12.48V11.48C24 6.08999 24 3.36999 22.31 1.69ZM18.14 7.76999C17.94 9.82999 17.09 14.84 16.66 17.15C16.48 18.15 16.12 18.46 15.77 18.49C15.01 18.56 14.43 17.99 13.7 17.49C12.55 16.73 11.9 16.26 10.79 15.49C9.49999 14.64 10.33 14.17 11.07 13.41C11.26 13.21 14.6 10.17 14.66 9.89999C14.6699 9.85968 14.6695 9.81755 14.6591 9.7774C14.6486 9.73725 14.6283 9.70033 14.6 9.66999C14.5583 9.64809 14.512 9.63665 14.465 9.63665C14.4179 9.63665 14.3716 9.64809 14.33 9.66999C14.22 9.66999 12.38 10.91 8.82999 13.31C8.42367 13.6293 7.92645 13.8114 7.40999 13.83C6.72755 13.7448 6.05674 13.5838 5.40999 13.35C4.59999 13.09 3.94999 12.95 3.99999 12.5C3.99999 12.26 4.35999 12.02 4.99999 11.77C8.80999 10.12 11.35 9.01999 12.62 8.49999C16.18 6.99999 16.93 6.75999 17.42 6.74999C17.6015 6.74487 17.7801 6.79738 17.93 6.89999C18.032 6.99111 18.0991 7.11483 18.12 7.24999C18.1383 7.42268 18.145 7.5964 18.14 7.76999Z",
    fill: "#99BE03"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "dzen",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.32 14.32C12.43 16.26 12.32 18.69 12.13 24C17.08 24 20.51 24 22.27 22.27C24.03 20.54 24 16.92 24 12.13C18.69 12.29 16.26 12.43 14.32 14.32ZM3.26046e-05 12.13C3.26046e-05 16.92 3.26633e-05 20.51 1.73003 22.27C3.46002 24.03 6.92001 24 11.87 24C11.71 18.69 11.57 16.26 9.68001 14.32C7.79001 12.38 5.31002 12.29 3.26046e-05 12.13ZM11.87 0C6.92001 0 3.49002 0 1.73003 1.73C-0.0299672 3.46 3.26046e-05 7.07999 3.26046e-05 11.87C5.31002 11.71 7.74001 11.57 9.68001 9.67999C11.62 7.78999 11.71 5.30999 11.87 0ZM14.32 9.67999C12.43 7.73999 12.32 5.30999 12.13 0C17.08 0 20.51 0 22.27 1.73C24.03 3.46 24 7.07999 24 11.87C18.69 11.71 16.26 11.57 14.32 9.67999Z",
    fill: "#99BE03"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "ok",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7474_104302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.31 1.69C20.63 0 17.91 0 12.48 0H11.48C6.09 0 3.37 0 1.69 1.69C0.0100001 3.38 0 6.09 0 11.52V12.52C0 17.95 0 20.67 1.69 22.35C3.38 24.03 6.09 24 11.52 24H12.52C17.95 24 20.67 24 22.35 22.31C24.03 20.62 24 17.91 24 12.48V11.48C24 6.09 24 3.37 22.31 1.69ZM12 3.43C12.877 3.42802 13.7349 3.68641 14.4649 4.17242C15.195 4.65843 15.7643 5.3502 16.1009 6.16009C16.4374 6.96997 16.526 7.86152 16.3554 8.72179C16.1847 9.58206 15.7626 10.3723 15.1425 10.9925C14.5223 11.6126 13.7321 12.0347 12.8718 12.2054C12.0115 12.376 11.12 12.2874 10.3101 11.9509C9.5002 11.6143 8.80843 11.045 8.32242 10.3149C7.83641 9.58489 7.57802 8.72702 7.58 7.85C7.58 6.67774 8.04568 5.5535 8.87459 4.72459C9.7035 3.89568 10.8277 3.43 12 3.43ZM16.36 14.82C15.568 15.3156 14.6997 15.6772 13.79 15.89L16.26 18.36C16.5027 18.6027 16.639 18.9318 16.639 19.275C16.639 19.6182 16.5027 19.9473 16.26 20.19C16.0173 20.4327 15.6882 20.569 15.345 20.569C15.0018 20.569 14.6727 20.4327 14.43 20.19L12 17.76L9.57 20.19C9.32528 20.4328 8.99472 20.5693 8.65 20.57C8.39556 20.5664 8.14776 20.4883 7.93732 20.3452C7.72688 20.2021 7.56307 20.0004 7.46618 19.7651C7.36929 19.5298 7.34359 19.2712 7.39226 19.0215C7.44094 18.7717 7.56185 18.5417 7.74 18.36L10.21 15.89C9.3003 15.6772 8.43196 15.3156 7.64 14.82C7.48883 14.7343 7.35653 14.619 7.25103 14.4809C7.14554 14.3429 7.06902 14.1849 7.02608 14.0165C6.98314 13.8482 6.97465 13.6728 7.00113 13.5011C7.02761 13.3294 7.08851 13.1648 7.18018 13.0172C7.27185 12.8696 7.39239 12.742 7.53458 12.6421C7.67677 12.5422 7.83767 12.4721 8.00762 12.436C8.17758 12.3998 8.35309 12.3983 8.52362 12.4317C8.69415 12.465 8.85618 12.5325 9 12.63C9.89794 13.1968 10.9381 13.4977 12 13.4977C13.0619 13.4977 14.1021 13.1968 15 12.63C15.1438 12.5394 15.304 12.478 15.4716 12.4493C15.6391 12.4206 15.8106 12.4252 15.9764 12.4628C16.1421 12.5004 16.2989 12.5703 16.4376 12.6685C16.5763 12.7667 16.6944 12.8912 16.785 13.035C16.8756 13.1788 16.937 13.339 16.9657 13.5066C16.9944 13.6741 16.9898 13.8456 16.9522 14.0114C16.9146 14.1771 16.8447 14.3339 16.7465 14.4726C16.6483 14.6113 16.5238 14.7294 16.38 14.82H16.36Z",
    fill: "#99BE03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.67953C12.3619 9.67953 12.7157 9.5722 13.0166 9.37112C13.3176 9.17004 13.5521 8.88423 13.6906 8.54984C13.8291 8.21545 13.8654 7.8475 13.7948 7.49252C13.7241 7.13753 13.5499 6.81146 13.2939 6.55553C13.038 6.2996 12.7119 6.12531 12.3569 6.0547C12.002 5.98408 11.634 6.02032 11.2996 6.15883C10.9652 6.29734 10.6794 6.5319 10.4783 6.83284C10.2772 7.13378 10.1699 7.48759 10.1699 7.84953C10.1699 8.33488 10.3627 8.80035 10.7059 9.14354C11.0491 9.48673 11.5146 9.67953 11.9999 9.67953Z",
    fill: "#99BE03"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7474_104302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "final-btn-green",
    viewBox: "0 0 173 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.353 8.99491L154.018 0H173V54H0V42.3584L11.1921 33.3018L0 36.3339V0H149.678L148.353 8.99491Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.d855027e257c66c8055f49fa3c024755.svg";
export { ForwardRef as ReactComponent };